import React, { Component } from 'react';
import { Link } from "react-router-dom";
import ScrollFadeIn from './../scrollFadeIn';
import './collectionBanner.css';

export default class extends Component {
  constructor(props) {
      super(props);
      this.state={};
  }
  render() {
    let backgroundPosition:'center'
    if(this.props.forceToTop){
      backgroundPosition = 'top'
    }
    if(this.props.forceToBottom){
      backgroundPosition = 'bottom'
    }
    let image = this.props.image;

    if(this.props.mobileOptimize && window.outerWidth < 800){
      image = this.props.image.replace('.jpg','-mobile.jpg');
    }
    let blackGlass = "rgba(0,0,0,0)";
    if(window.location.href.indexOf('/about') != -1){
      blackGlass = "rgba(0,0,0,.25)";
    }
    return(
      <div
        className="collection-banner-outside"
        style={{
          height:window.innerHeight,
          backgroundImage:'url('+image+')',
          backgroundPosition:backgroundPosition
        }}>
        <div className="full-height full-width horizontal-overlay-gradient" style={{display:'flex',alignItems:'center',backgroundColor:blackGlass}}>
          <div className={"medium-padding shifter "+this.props.transitionClass}>
            {this.props.subtitle && <h6 className="white tiny-top-margin">{this.props.subtitle}</h6>}
            <h1 className="white">{this.props.title}</h1>
            {this.props.link &&
              <Link className="button primary-background white" to={this.props.link} style={{color:"#fff"}}>{'Explore'}</Link>
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/collectionBanner/index.js